// league-schedule.js -- how often a league PLAYS and what slate window the Home
// schedule card shows for it (#1082). Single job: cadence lookup + window maths.
// Reads SUPPORTED_LEAGUES (drift test pins the table's keys to it); writes
// nothing; no React, no Supabase.
//
// A daily league (NHL, MLB) shows today's games -- the realtime 3-day feed
// already carries them. A weekly league (NFL: Thu/Sun/Mon, most days empty)
// shows a rolling window of yesterday..today+6 so a bet imported on Wednesday
// for Sunday's game has something to look at, and Tuesday still shows Monday
// night's result. Rolling calendar days, not the ESPN week number: game_cache
// has no week column and a calendar window is league-agnostic.
//
// Own-property guard: a poisoned key ("constructor") must not resolve to an
// Object.prototype member; unknown keys fail closed to 'daily'.
import { SUPPORTED_LEAGUES } from './constants';

export const SCHEDULE_CADENCE = Object.freeze({ nhl: 'daily', mlb: 'daily', nfl: 'weekly' });

const WEEKLY_BACK_DAYS = 1;
const WEEKLY_FORWARD_DAYS = 6;

const has = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);

export function scheduleCadence(league) {
  return SUPPORTED_LEAGUES.includes(league) && has(SCHEDULE_CADENCE, league)
    ? SCHEDULE_CADENCE[league]
    : 'daily';
}

// Local calendar date as YYYY-MM-DD (matches game.gameDate / game_cache.game_date).
export function localDateKey(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

function shiftDays(d, days) {
  const out = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  out.setDate(out.getDate() + days);
  return out;
}

// Inclusive [from, to] window of local date keys for the league's slate.
export function scheduleWindow(league, now = new Date()) {
  if (scheduleCadence(league) === 'weekly') {
    return { from: localDateKey(shiftDays(now, -WEEKLY_BACK_DAYS)), to: localDateKey(shiftDays(now, WEEKLY_FORWARD_DAYS)) };
  }
  const today = localDateKey(now);
  return { from: today, to: today };
}
